import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { g as getNamespacedTagFor } from './index-739b155e.js';

const marketPaginationCss = ":host{display:flex;flex-direction:column;align-items:stretch}.market-button-dropdown{display:flex;flex-direction:column;align-items:stretch}.market-button-dropdown market-filter-button{display:block}.market-pagination-page-size+.market-pagination-nav{margin-top:var(--pagination-nav-vertical-margin, var(--core-metrics-spacing-200))}@media only screen and (min-width: 600px){.market-pagination-page-size+.market-pagination-nav{margin-top:0;margin-left:var(--pagination-nav-horizontal-margin, var(--core-metrics-spacing-100))}}.market-pagination-nav nav{display:flex;justify-content:space-between;-moz-column-gap:var(--pagination-nav-content-spacing, var(--core-metrics-spacing-100));column-gap:var(--pagination-nav-content-spacing, var(--core-metrics-spacing-100))}.market-pagination-nav nav market-button-dropdown{flex-grow:1}@media only screen and (min-width: 600px){:host{flex-direction:row;justify-content:space-between}.market-pagination-nav:only-child{margin-left:auto}}";

const MarketPagination = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.marketPaginationPageSizeChange = createEvent(this, "marketPaginationPageSizeChange", 7);
    this.marketPaginationNavigation = createEvent(this, "marketPaginationNavigation", 7);
    this.currentPage = undefined;
    this.totalPages = undefined;
    this.hasNextPage = undefined;
    this.hasPreviousPage = undefined;
    this.pageSize = undefined;
    this.pageSizeOptions = undefined;
  }
  /**
   * Rebroadcast up events from market-pagination-page-size.
   */
  changePageSize(e) {
    e.stopPropagation();
    const { detail } = e;
    this.marketPaginationPageSizeChange.emit(detail);
  }
  /**
   * Rebroadcast up events from market-pagination-nav.
   */
  navigatePage(e) {
    e.stopPropagation();
    const { detail } = e;
    this.marketPaginationNavigation.emit(detail);
  }
  render() {
    const MarketPaginationPageSizeTagName = getNamespacedTagFor('market-pagination-page-size');
    const MarketPaginationNavTagName = getNamespacedTagFor('market-pagination-nav');
    return (h(Host, { class: "market-pagination" }, this.pageSizeOptions && (h(MarketPaginationPageSizeTagName, { value: this.pageSize, pageSizeOptions: this.pageSizeOptions }, h("slot", { name: "page-size-label", slot: "page-size-label" }, "Results per page"), h("slot", { name: "page-size-feedback", slot: "page-size-feedback" }, this.pageSize))), h(MarketPaginationNavTagName, { currentPage: this.currentPage, totalPages: this.totalPages, pageSize: this.pageSize, hasNextPage: this.hasNextPage, hasPreviousPage: this.hasPreviousPage }, h("slot", { name: "nav-label", slot: "nav-label" }, "Page"), h("slot", { name: "nav-feedback", slot: "nav-feedback" }, this.currentPage, " of ", this.totalPages))));
  }
  get el() { return getElement(this); }
};
MarketPagination.style = marketPaginationCss;

export { MarketPagination as market_pagination };
